<div class="modal" tabindex="0" aria-modal="true" data-action-target="modal-container">
  <span id="dialog-live-region" class="sr-live-region" aria-live="polite" aria-atomic="true"></span>
  <div
  class="modal__container"
  data-dismiss="modal"
  data-content="dialog-atom-region"></div>
</div>